/**
 * lineColour — the status colour of a runsheet line, shared by the runsheet rows and the
 * Run map's markers.
 *
 * Status rules from templates/dashboard.html, kept for parity:
 *   complete    → driver_locked
 *   nopickup    → num_bags==0 (and not INSTALL) or pickupcode=='Overdue'
 *   extrapickup → pickupcode=='EXTRA PICKUP'
 *   install     → INSTALL WHEELIE BINS or INSTALL FRAME
 *   pending     → anything else
 */

import type { RunsheetLine } from '@/types';

/** A Mantine colour name. */
export type LineColour = 'green' | 'gray' | 'orange' | 'violet' | 'blue';

export function lineColour(item: RunsheetLine): LineColour {
  if (item.driver_locked) return 'green';
  if (
    (item.num_bags === 0 && !item.pickupcode.match(/install/i)) ||
    item.pickupcode.match(/overdue/i)
  )
    return 'gray';
  if (item.pickupcode === 'EXTRA PICKUP') return 'orange';
  if (item.pickupcode.match(/install/i)) return 'violet';
  return 'blue';
}
